import React, { useState, useEffect } from "react";
import {
  Pagination,
  Grid,
  SvgIcon,
  Drawer,
  Divider,
  PaginationItem,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CssBaseline,
  AppBar,
  Toolbar,
  LinearProgress,
  Paper,
  Stack,
  Avatar,
  useTheme,
  useMediaQuery,
  ListItemText,
  Chip,
  IconButton,
  Alert,
} from "@mui/material";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import "./ReViewExamPractice.scss"; // For additional styling
import Brightness1Icon from "@mui/icons-material/Brightness1";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Chatbot from "../../Components/Chatbot/Chatbot";
import Correctanswer from "../../Assets/Images/Correctanswer.svg";
import Wronganswer from "../../Assets/Images/Wronganswer.svg";
import { ReactComponent as Chatbotboticon } from "../../Assets/Images/chatbot 1.svg";
import { successChatbot } from "../../Redux/Slices/Chatbot/ChatbotSlicer";
import { listReViewExamID } from "../../Redux/Slices/ReViewExam/ListReViewExamSlice";
import AlterDialog from "../../Components/AlterDialog/AlterDialog";
import ButtonField from "../../Components/Button/ButtonField";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AvatarImage from "../../Assets/Images/Chatbot_Avatar.png";
import {
  clearListReViewExamIDPractice,
  listReViewExamIDPractice,
} from "../../Redux/Slices/ReViewExamPractice/ListReViewExamPracticeSlice";
import { listListWritingExamAIPracticeSlice } from "../../Redux/Slices/Writing_Exam_Practice/ListWriting_Exam_AI_PracticeSlice";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import QuillEditor from "quill";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  clearListWritingExamPracticeSlice,
  listListWritingExamPracticeSlice,
} from "../../Redux/Slices/Writing_Exam_Practice/ListWriting_Exam_PracticeSlice";
import InfoIcon from "@mui/icons-material/Info";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import AppBarnav from "../../Components/AppBar/AppBar";
import Loading from "../../Components/Loading/Loading";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import StatusLegend from "../../Components/StatusLegend/StatusLegent";
import ChatIcon from "@mui/icons-material/Chat";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StatusLegends from "../../Components/StatusLIst";
import CircleIcon from "@mui/icons-material/Circle";
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { listEvaluation } from "../../Redux/Slices/Exam/ListEvaluationSlice";
import { listEvaluationPractice } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import { Console } from "node:console";
import ChatbotPublic from "../../Components/ChatbotPublic/ChatbotPublic";
import { clearChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ChatbotPublicSlicer";

import { clearReadChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/ReadChatbotPublicSlicer";
import { clearWritingChatbotPublicStatus } from "../../Redux/Slices/ChatbotPublic/WritingChatbotPublicSlicer";

interface Question {
  id: number;
  question_type: string;
  question: string;
  question_url: string;
  imgWidth?: number;
  prompt: string;
  subtype_name: string;

  response: string;
  rewritten_response?: string;
  instruction: string;
  answer_explanation?: string;
  explanation: any;
  options: {
    optionname: string;
    option_id: number;
    is_correct: boolean;
    chosen: boolean;
    comment: string | null;
  }[];
  optionsurl: {
    optionname: string;
    option_id: number;
    is_correct: boolean;
    chosen: boolean;
    comment: string | null;
  }[];
}

// Register necessary modules
const FontSize = ReactQuill.Quill.import("formats/size");
FontSize.whitelist = ["small", false, "large", "huge"];
ReactQuill.Quill.register(FontSize, true);

const Align = ReactQuill.Quill.import("formats/align");
Quill.register(Align, true);
const modules = {
  toolbar: [
    // [{ header: [false, 1, 2, 3, 4, 5, 6] }, { font: [] }], // Paragraph styles (headers) and font
    // [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    // [{ color: [] }, { background: [] }], // Text and background color
    // [{ script: "sub" }, { script: "super" }], // Subscript/superscript
    [{ list: "ordered" }, { list: "bullet" }],
    // [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    // [{ direction: "rtl" }], // Right-to-left (if needed)
    ["blockquote", "code-block"],
    // ["link", "image", "formula"], // Link, image, formula
    // ["clean"], // Clear formatting
    // [{ undo: { icon: "undo" } }, { redo: { icon: "redo" } }], // Correct undo/redo
  ],
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

const formats = [
  // "header",
  // "font",
  // "size",
  "bold",
  "italic",
  "underline",
  "strike",
  // "color",
  // "background",
  "script",
  "list",
  "bullet",
  "indent",
  "direction",
  "blockquote",
  // "code-block",
  "align",
  // "link",
  // "image",
  // "formula",
];

const ReViewExamPractice: React.FC = () => {
  const navigate = useNavigate();
  const { state: view_id } = useLocation();
  console.log("view astate", view_id);

  // overall data list
  const { data: listReViewExamIDSlice, isLoading: Reviewdata } = useAppSelector(
    (state) => state.ListReViewExamIDPracticeSlice
  );

  const { data: WritingExamPracticeSlice, isLoading: WrittingData } =
    useAppSelector((state) => state.ListWritingExamPracticeSlice);

  const List: any = view_id?.id
    ? WritingExamPracticeSlice
    : listReViewExamIDSlice;

  console.log("WritingExamPracticeSlice", WritingExamPracticeSlice?.data);

  const { data: WritingExamAIPracticeSlice, isLoading: WrittingAIPractice } =
    useAppSelector((state) => state.ListWritingExamAIPracticeSlice);
  const AI: any = WritingExamAIPracticeSlice?.data;

  //   dialog box
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  function handleListItemClick(questionType: number) {
    const questionIndex = List?.data?.questions?.findIndex(
      (question: any) => question.questionType === questionType
    );
    setCurrentQuestion(questionIndex + 1);
  }

  // Text Editor
  // const [editorValue, setEditorValue] = useState<string>(
  //   List?.data?.questions[0]?.ai_response
  // );

  const [aiwrite, writeexam] = useState<string>("aiwriting");
  const [aiwritere, writeexamre] = useState<string>("aiwritingre");

  useEffect(() => {
    const filteredQuestionType = List?.data?.questions?.map(
      (question: any) => ({
        id: question?.id,
        question_type: question?.question_type_name,
        question_url: question?.question_url,
        imgWidth: question?.imgWidth,
        question: question?.question,
        prompt: question?.prompt,
        subtype_name: question?.subType_name,
        instruction: question?.instruction,
        answer_explanation: question?.explanation,
        explanation: question?.explanation,
        rewritten_response: question?.rewritten_response,
        response: question?.ai_response,
        options: question?.options?.map((opt: any) => ({
          optionname: opt?.option,
          option_id: opt?.id,
          is_correct: opt?.answer,
          chosen: opt?.chosen,
          comment: opt?.comment,
        })),
        optionsurl: question?.options?.map((opt: any) => ({
          optionname: opt?.option_url,
          option_id: opt?.id,
          is_correct: opt?.answer,
          chosen: opt?.chosen,
          comment: opt?.comment,
        })),
      })
    );

    if (filteredQuestionType?.length > 0) {
      // setEditorValue(questions[currentQuestion - 1]?.response);
      setQuestions(filteredQuestionType);
    }
  }, [List]);

  const [currentQuestion, setCurrentQuestion] = useState<number>(1);

  const [questions, setQuestions] = useState<Question[]>([]); // Initialize with predefined data
  const [isExamOver, setIsExamOver] = useState<boolean>(false);

  const submitExam = () => {
    setIsExamOver(true);
  };

  // Disable spellcheck as component is mounted
  const ref = React.useRef<ReactQuill & { editor: QuillEditor }>(null);
  React.useEffect(() => {
    ref.current?.editor.root.setAttribute("spellcheck", "false");
  }, []);

  const renderQuestionOptions = (
    questionId: number,
    answer_explanation: string,
    question_type: string,
    options: {
      optionname: string;
      option_id: number;
      is_correct: boolean;
      chosen: boolean;
      comment: string | null;
    }[],
    optionsurl: {
      optionname: string;
      option_id: number;
      is_correct: boolean;
      chosen: boolean;
      comment: string | null;
    }[]
  ) => {
    const hasNullUrl = optionsurl?.some(
      (option) => option?.optionname === null
    );
    return (
      <>
        <Grid
          spacing={3}
          sx={{
            ...(question_type === "Reading Comprehension" ||
              question_type === "Writing"
              ? {
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "30px",
              }
              : {
                margin: "0px",
                marginTop: "20px",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                width: "100%",
                gap: "30px",
              }),
          }}
        >
          {hasNullUrl
            ? options?.map((option, index) => {
              const isReadingComprehension =
                question_type === "Reading Comprehension";

              let message = null;
              let messageColor = "";

              if (option?.chosen && option?.is_correct) {
                message = (
                  <>
                    <img
                      src={Correctanswer}
                      alt="Correct answer"
                      style={{ marginRight: 8, height: 16 }}
                    />
                    Correct Answer
                  </>
                );
                messageColor = "#22c55e"; // Green
              } else if (option?.chosen && !option?.is_correct) {
                message = (
                  <>
                    <img
                      src={Wronganswer}
                      alt="Wrong answer"
                      style={{ marginRight: 8, height: 16 }}
                    />
                    Your Answer
                  </>
                );
                messageColor = "#ef4444"; // Red
              } else if (!option?.chosen && option?.is_correct) {
                message = (
                  <>
                    <img
                      src={Correctanswer}
                      alt="Correct answer"
                      style={{ marginRight: 8, height: 16 }}
                    />
                    Correct Answer
                  </>
                );
                messageColor = "#22c55e"; // Green
              }

              const isChosenWrong = option.chosen && !option.is_correct;
              const isCorrect = option.is_correct;

              const bgColor = isCorrect
                ? "#ecfdf5"
                : isChosenWrong
                  ? "#fef2f2"
                  : "#fff";
              const borderColor = isCorrect
                ? "#22c55e"
                : isChosenWrong
                  ? "#ef4444"
                  : "#e5e7eb";
              const textColor = isChosenWrong ? "#ef4444" : "#111827";

              return (
                <Grid item xs={12} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: `2px solid ${borderColor}`,
                      borderRadius: 2,
                      padding: 2,
                      backgroundColor: bgColor,
                      color: textColor,
                      transition: "all 0.2s ease",
                    }}
                  >
                    {/* Option icon + label */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          backgroundColor: isCorrect
                            ? "#22c55e"
                            : isChosenWrong
                              ? "#ef4444"
                              : "#e5e7eb",
                          color: "#fff",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                        }}
                      >
                        {String.fromCharCode(65 + index)}
                      </Box>
                      <Typography sx={{ fontWeight: 500, maxWidth: "85%", fontSize: "14px" }}>
                        {option.optionname}
                      </Typography>
                    </Box>

                    {/* Status Message */}
                    {message && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          color: messageColor,
                          fontWeight: 500,
                          fontSize: 14,
                          maxWidth: "80%",
                        }}
                      >
                        {message}
                      </Box>
                    )}
                  </Box>
                </Grid>
              );
            })
            : optionsurl?.map((option, index) => {
              const isReadingComprehension =
                question_type === "Reading Comprehension";
              let message = null;
              let messageColor = "";

              if (option?.chosen && option?.is_correct) {
                message = (
                  <>
                    <img
                      src={Correctanswer}
                      alt="Correct"
                      style={{ marginRight: 8, height: 16 }}
                    />
                    Your Answer is Correct
                  </>
                );
                messageColor = "#22c55e";
              } else if (option?.chosen && !option?.is_correct) {
                message = (
                  <>
                    <img
                      src={Wronganswer}
                      alt="Wrong"
                      style={{ marginRight: 8, height: 16 }}
                    />
                    Your Answer is Wrong
                  </>
                );
                messageColor = "#ef4444";
              } else if (!option?.chosen && option?.is_correct) {
                message = (
                  <>
                    <img
                      src={Correctanswer}
                      alt="Correct"
                      style={{ marginRight: 8, height: 16 }}
                    />
                    This is Correct Answer
                  </>
                );
                messageColor = "#22c55e";
              }

              const isChosenWrong = option.chosen && !option.is_correct;
              const isCorrect = option.is_correct;

              const bgColor = isCorrect
                ? "#ecfdf5"
                : isChosenWrong
                  ? "#fef2f2"
                  : "#ffffff";
              const borderColor = isCorrect
                ? "#22c55e"
                : isChosenWrong
                  ? "#ef4444"
                  : "#e5e7eb";

              return (
                <Grid item xs={12} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: `2px solid ${borderColor}`,
                      borderRadius: 2,
                      padding: 2,
                      backgroundColor: bgColor,
                      transition: "all 0.2s ease",
                    }}
                  >
                    {/* Option Label + Image */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {/* Circle A/B/C */}
                      <Box
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          backgroundColor: isCorrect
                            ? "#22c55e"
                            : isChosenWrong
                              ? "#ef4444"
                              : "#e5e7eb",
                          color: "#fff",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: 2,
                        }}
                      >
                        {String.fromCharCode(65 + index)}
                      </Box>

                      {/* Image Option */}
                      <img
                        src={option?.optionname}
                        alt={`Option ${index}`}
                        style={{ maxHeight: "55px", maxWidth: "100px" }}
                      />
                    </Box>

                    {/* Message */}
                    {message && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          color: messageColor,
                          fontWeight: 500,
                          fontSize: 14,
                        }}
                      >
                        {message}
                      </Box>
                    )}
                  </Box>
                </Grid>
              );
            })}
        </Grid>
        {answer_explanation && (
          <Box
            sx={{
              backgroundColor: "#f0f7ff", // light blue background
              borderRadius: "10px",
              padding: "16px",
              width: "100%",
              marginTop:
                question_type === "Reading Comprehension" ? "20px" : "20px",
              marginLeft:
                question_type === "Reading Comprehension" ? "0px" : "10px",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                fontSize: "18px",
                color: "#1e3a8a", // dark blue heading
                marginBottom: "6px",
              }}
            >
              Explanation
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontSize: "15px",
                color: "#1e3a8a", // same dark blue
                lineHeight: 1.5,
              }}
            >
              {answer_explanation}
            </Typography>
          </Box>
        )}
      </>
    );
  };

  // chatbot
  const [chatbotOpen, setChatbotOpen] = React.useState<boolean>(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (view_id?.id) {
      dispatch(
        listListWritingExamPracticeSlice({ student_test_id: view_id?.id })
      );
    } else {
      dispatch(listReViewExamIDPractice({ id: view_id }));
    }
  }, [view_id?.id]);

  // question image show
  const imageFile = questions[currentQuestion - 1]?.question_url;

  // is pending exam list popup
  const [openreview, setOpenreview] = React.useState(false);

  useEffect(() => {
    if (List?.status === false) {
      setOpenreview(true); // Open only if both conditions are true
    } else {
      setOpenreview(false); // Close if any condition is false
    }
  }, [List]); // Dependencies

  const handleClosereview = () => {
    setOpenreview(false);
  };

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (
      Reviewdata === true ||
      WrittingData === true ||
      WrittingAIPractice === true
    ) {
      setLoading(true); // Open only if both conditions are true
    } else {
      setLoading(false); // Close if any condition is false
    }
  }, [Reviewdata === true, WrittingData === true, WrittingAIPractice === true]); // Dependencies
  const progress = (currentQuestion / questions?.length) * 100;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let adaptImageWidth = useMediaQuery("(min-width: 768px)")


  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  // writitg  exam

  // color based
  const getBackgroundColor = (options: any[]): string => {
    const chosenOption = options?.find((opt) => opt.chosen);

    if (!chosenOption) {
      return "#f9fafb"; // No option chosen
    }

    return chosenOption.is_correct ? "#ecfdf5" : "#fef2f2";
  };

  type Option = {
    chosen: boolean;
    is_correct: boolean;
  };

  type OptionFeedback = {
    bgColor: string;
    image: string;
    label: string;
    color: string;
  };

  const getOptionFeedback = (options: Option[]): OptionFeedback => {
    const chosenOption = options?.find((opt) => opt.chosen);

    if (!chosenOption) {
      return {
        bgColor: "#f9fafb", // Neutral color
        image: Wronganswer, // Use wrong image for unanswered
        label: "Not answered",
        color: "#e5e7eb",
      };
    }

    if (chosenOption.is_correct) {
      return {
        bgColor: "#ecfdf5", // Green
        image: Correctanswer,
        label: "Correct",
        color: "#22c55e",
      };
    } else {
      return {
        bgColor: "#fef2f2", // Red
        image: Wronganswer,
        label: "Incorrect",
        color: "#ef4444",
      };
    }
  };

  const feedback = getOptionFeedback(questions[currentQuestion - 1]?.options);

  const getPaginationStatus = (options: any[]) => {
    const chosenOption = options?.find((opt) => opt.chosen);

    if (!chosenOption) {
      return {
        backgroundColor: "#f3f4f6", // gray-100
        icon: "", // No icon or 🕓
        color: "black",
      };
    }

    if (chosenOption.is_correct) {
      return {
        backgroundColor: "#bbf7d0", // green-100
        icon: "✅",
        color: "black",
      };
    }

    return {
      backgroundColor: "#fecaca", // red-100
      icon: "❌",
      color: "black",
    };
  };

  // writing page

  const [showErrors, setShowErrors] = useState(false);
  const [processedResponse, setProcessedResponse] = useState(null);
  const [errorCount, setErrorCount] = useState(0); // State to hold the count of highlighted errors

  // Function to parse the HTML string and highlight <b> and <strong> tags

  const parseAndHighlightHtml: any = (htmlString: any) => {
    if (!htmlString) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const nodes = Array.from(doc.body.childNodes);
    let count = 0;

    const processNode = (node: any, key: any) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return <React.Fragment key={key}>{node.textContent}</React.Fragment>;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName === "Q") {
          count++; // Increment error count
          return (
            <span
              key={key}
              style={{
                color: "#991b1b", // Dark red text
                background: "#fce4ec", // Light pink background
                padding: "2px 4px",
                border: "1px solid #991b1b",
                borderRadius: "4px",
                fontSize: "16px",
                fontWeight: "500",
                whiteSpace: "pre-wrap", // ← Preserve all spaces and line breaks
              }}
            >
              {node?.textContent}
            </span>
          );
        } else {
          const children = Array.from(node.childNodes).map((child, index) =>
            processNode(child, `${key}-${index}`)
          );

          if (node.tagName === "STRONG" || node.tagName === "B") {
            return (
              <span
                key={key}
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {node.textContent}
              </span>
            );
          }

          if (node.tagName === "BR") {
            return <br key={key} />;
          }

          if (node.tagName === "P") {
            return (
              <p key={key} style={{ fontSize: "18px" }}>
                {children}
              </p>
            );
          }

          return <React.Fragment key={key}>{children}</React.Fragment>;
        }
      }
      return null;
    };

    const result = nodes.map((node, index) => processNode(node, index));
    setErrorCount(count); // Set the error count
    return result;
  };

  useEffect(() => {
    setProcessedResponse(
      parseAndHighlightHtml(questions[currentQuestion - 1]?.response)
    );
  }, [questions[currentQuestion - 1]?.response]);

  // writng
  const stripHtmlTags = (htmlString: string) => {
    const div = document.createElement("div");
    div.innerHTML = htmlString;
    return div.textContent || div.innerText || "";
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        ["INPUT", "TEXTAREA"].includes((event.target as HTMLElement).tagName)
      ) {
        return;
      }

      switch (event.key) {
        case "ArrowRight":
          // Next question
          setCurrentQuestion((prev) => Math.min(prev + 1, questions?.length));
          break;
        case "ArrowLeft":
          // Previous question
          setCurrentQuestion((prev) => Math.max(prev - 1, 1));
          break;
        case "c":
        case "C":
          // Clear answer (if applicable)
          // You might want to implement this based on your requirements
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [questions?.length]);

  const parseHtmlToParagraphs = (htmlString: string) => {
    if (!htmlString) return null;

    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Get all child nodes
    const nodes = Array.from(tempDiv.childNodes);

    return nodes.map((node, index) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return (
          <Typography
            key={index}
            component="p"
            sx={{ mb: 1.5, fontSize: "17px" }}
          >
            {node.textContent}
          </Typography>
        );
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.nodeName === "P") {
          return (
            <Typography
              key={index}
              component="p"
              sx={{ mb: 1.5, fontSize: "17px" }}
            >
              {node.textContent}
            </Typography>
          );
        } else if (node.nodeName === "BR") {
          return <br key={index} />;
        } else {
          return (
            <Typography
              key={index}
              component="p"
              sx={{ mb: 1.5, fontSize: "17px" }}
            >
              {node.textContent}
            </Typography>
          );
        }
      }
      return null;
    });
  };

  return (
    <>
      {loading && <Loading isLoading={loading} />}

      {!List?.data ||
        (List.data.length === 0 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CircularProgress />
          </Box>
        ))}

      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin:
                questions[currentQuestion - 1]?.question_type === "Writing"
                  ? "0% 0.5%"
                  : "0% 3%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
                onClick={() => {
                  navigate("/dashboard"); // Replace with your target route
                }}
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate("/dashboard"); // Replace with your target route
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "15px" }}>
                  {" "}
                  Back to Tests
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
        </Box>
      </Box>

      <div style={{ height: "50px" }} />
      {loading && <Loading isLoading={loading} />}
      <div className="unselectable" style={{ backgroundColor: "#f5f9ff" }}>
        {questions[currentQuestion - 1]?.question_type === "Writing" ? null : (
          <>
            {questions[currentQuestion - 1]?.question_type ===
              "Reading Comprehension" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    color: "#1e3a8a",
                    fontWeight: 700,
                    fontSize: "28px",
                    margin: "2% 4.5% 0.5% 4.5%",
                    padding: "5px 0",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {List?.data?.exam_name}&nbsp; : &nbsp;Solution Review
                </div>
                <div
                  style={{
                    display: "flex",
                    color: "#4b5563",
                    fontSize: "18px",
                    margin: "0% 4.5% 2%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Review your answers and understand the explanations
                </div>
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  color: "#1e3a8a",
                  fontWeight: 700,
                  fontSize: "24px",
                  margin:
                    questions[currentQuestion - 1]?.question_type === "Writing"
                      ? "2% 1% 0.5%"
                      : "2% 4.5% 0.5% 4.5%",
                  alignItems: "center",
                }}
              >
                {List?.data?.exam_name}&nbsp; : &nbsp;Solution Review
                <div
                  style={{
                    textTransform: "capitalize",
                    color: "#009dff",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  &nbsp; Question {currentQuestion} of {""}
                  {questions?.length}{" "}
                </div>
              </div>
            )}

            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                margin:
                  questions[currentQuestion - 1]?.question_type === "Writing"
                    ? "0% 1%"
                    : "0% 4.5% 1%",
                padding: "5px",
                borderRadius: "10px",
              }}
            />
          </>
        )}
        {questions[currentQuestion - 1]?.question_type === "Writing" ? null : (
          <div style={{ margin: "0.5% 4.5%" }}>
            <Pagination
              count={questions.length}
              variant="outlined"
              siblingCount={6}
              boundaryCount={1}
              page={currentQuestion}
              onChange={(event, value) => setCurrentQuestion(value)}
              renderItem={(item: any) => {
                if (item.type === "previous" || item.type === "next")
                  return null;

                if (item.type === "page") {
                  const questionOptions =
                    questions[item.page - 1]?.options || [];
                  const { backgroundColor, icon, color } =
                    getPaginationStatus(questionOptions);

                  const isActive = item.page === currentQuestion;

                  return (
                    <Button
                      sx={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "50%",
                        backgroundColor: isActive
                          ? "linear-gradient(to right, #00aaff, #88e1ff)"
                          : backgroundColor,
                        color: "black",
                        minWidth: "unset",
                        padding: 0,
                        marginLeft: "5px",
                        marginTop: "3px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                      onClick={() => setCurrentQuestion(item.page)}
                    >
                      {icon !== "" && (
                        <span
                          style={{
                            fontSize: "10px",
                            marginTop: "-12px",
                            marginLeft: "21px",
                          }}
                        >
                          {icon}
                        </span>
                      )}

                      {item.page}
                    </Button>
                  );
                }

                return <PaginationItem {...item} />;
              }}
            />

            <StatusLegends />
          </div>
        )}

        {questions[currentQuestion - 1]?.question_type === "Writing" ? (
          <>
            <div
              style={{
                display: "flex",
                color: "#1e3a8a",
                fontWeight: 700,
                fontSize: "36px",
                lineHeight: "40px",
                margin: "2% 4.5% 1% 4.5%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {List?.data?.exam_name}&nbsp; : &nbsp;Solution Review
            </div>
            <div
              style={{
                display: "flex",
                color: "#4b5563",
                fontSize: "18px",
                margin: "0% 4.5% 2%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Review your writing and understand the AI feedback
            </div>

            <Box
              sx={{
                flexGrow: 1,
                padding: "10px 6%",
                margin: "0px 0 10px 0",
              }}
            >
              {/* Chat Suggestion Box */}
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "12px",
                  padding: "16px  16px",
                  display: "flex",
                  justifyContent: "space-between",
                  background: "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                  alignItems: "center",
                  borderColor: "#bfdbfe",
                  borderWidth: "2px",
                  borderStyle: "solid",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <div className="blinking-avatar-container1">
                    <Avatar
                      src={AvatarImage}
                      alt="Profile"
                      className="blinking-avatar1"
                    />
                  </div>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "18px",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        color: "#1e3a8a",
                      }}
                    >
                      Need help understanding?
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "#424242" }}>
                      Chat with Elliot about this question!
                    </Typography>
                  </Box>
                </Stack>

                <Button
                  variant="contained"
                  startIcon={<ChatBubbleOutlineIcon />}
                  sx={{
                    borderRadius: "10px",
                    fontWeight: 600,
                    textTransform: "none",
                    px: 3,
                    py: 1,
                    color: "white",
                    fontSize: "15px",
                    backgroundColor: "#2196f3",
                    "&:hover": {
                      backgroundColor: "#1976d2",
                    },
                  }}
                  onClick={() => {
                    setChatbotOpen(true);
                    dispatch(clearChatbotPublicStatus());
                    dispatch(clearWritingChatbotPublicStatus());
                    dispatch(clearReadChatbotPublicStatus());
                  }}
                >
                  Chat with Elliot
                </Button>
              </Paper>
            </Box>

            <ChatbotPublic
              open={chatbotOpen}
              setOpen={setChatbotOpen}
              state_value={view_id}
              review_screen={WritingExamPracticeSlice?.data}
            />

            <Box
              sx={{
                flexGrow: 1,
                padding: "16px 6%",
                margin: "0px 0 10px 0",
              }}
            >
              <Grid container spacing={3}>
                {/* Left Column - Writing Prompt */}
                <Grid item xs={12} md={6}>
                  <Paper
                    sx={{
                      height: "100%",
                      boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                    }}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        height: "70px",
                        background:
                          "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "30px",
                        color: "#1e3a8a",
                        fontSize: "20px",
                        fontWeight: 500,
                        borderRadius: "10px 10px 0px 0px",
                      }}
                    >
                      Writing Prompt
                    </Typography>

                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        padding: 2,
                        minHeight: 200,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "30px",
                        backgroundColor: "#f9fafb",
                      }}
                    >
                      <img
                        src={imageFile}
                        alt="Writing prompt"
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                      />
                    </Box>

                    <Typography
                      variant="body1"
                      sx={{
                        padding: 2,
                        margin: "30px",
                        fontSize: "16px",
                        background:
                          "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                      }}
                    >
                      Look at the image above and write a creative piece inspired by what you see. You may choose any writing style - narrative, descriptive, persuasive, or analytical.
                    </Typography>
                  </Paper>
                </Grid>

                {/* Right Column - User Submission */}
                {/* <Grid item xs={12} md={6}>
                  <Paper sx={{ height: "100%" }}>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        height: "70px",
                        background:
                          "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "30px",
                        color: "#1e3a8a",
                        fontSize: "20px",
                        fontWeight: 500,
                        justifyContent: "space-between",
                      }}
                    >
                      Your Submission
                      {showErrors && (
                        <Typography
                          variant="subtitle1"
                          color="error"
                          sx={{ fontWeight: "bold" }}
                        >
                          {ListData?.length} errors found
                        </Typography>
                      )}
                    </Typography>

                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        padding: 2,
                        minHeight: 200,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "30px",
                        backgroundColor: "#f9fafb",
                      }}
                    >
                      <div style={{ maxWidth: "100%", color: "#000" }}>
                        {questions[currentQuestion - 1]?.response}
                      </div>
                    </Box>

                    <Box sx={{ maxWidth: 600, margin: "0 auto" }}>
                      {!showErrors && (
                        <Button variant="contained" onClick={handleButtonClick}>
                          Show Error Explanations
                        </Button>
                      )}

                      {showErrors && (
                        <Accordion defaultExpanded>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{
                              backgroundColor: "#fce4ec",
                              color: "#c62828",
                              minHeight: "48px", // Ensure consistent height
                              "& .MuiAccordionSummary-content": {
                                margin: "12px 0", // Adjust content vertical alignment
                              },
                            }}
                          >
                            <ListItemIcon sx={{ minWidth: 30 }}>
                              <ErrorOutlineIcon sx={{ color: "#c62828" }} />
                            </ListItemIcon>
                            <Typography variant="subtitle1" fontWeight="bold">
                              Error Explanations ({ListData?.length})
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails sx={{ padding: 0 }}>
                            <List>
                              {ListData?.map((errorItem: any, index: any) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    backgroundColor: "#fff3e0",
                                    color: "#d84315",
                                    marginBottom: "8px",
                                    borderRadius: "4px",
                                    padding: "10px 16px",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Typography variant="body1" fontWeight="bold">
                                    {errorItem?.original} →{" "}
                                    {errorItem?.corrected}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ mt: 0.5, color: "#bf360c" }}
                                  >
                                    {errorItem?.explanation}
                                  </Typography>
                                </ListItem>
                              ))}
                            </List>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </Box>
                  </Paper>
                </Grid> */}
                <Grid item xs={12} md={6}>
                  <Paper
                    sx={{
                      height: "100%",
                      boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                    }}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "70px",
                        background:
                          "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                        padding: "30px",
                        color: "#1e3a8a",
                        fontSize: "20px",
                        fontWeight: 400,
                        borderRadius: "10px 10px 0px 0px",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          color: "#1e3a8a",
                          fontSize: "20px",
                          fontWeight: 500,
                        }}
                      >
                        Your Submission
                      </Typography>

                      <Typography
                        sx={{
                          display: "flex",
                          justifycontent: "center",
                          alignitems: "center",
                          fontsize: "14px",
                          fontweight: "500",
                        }}
                      >
                        {errorCount && (
                          <Typography
                            variant="subtitle1"
                            color="error"
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "5px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <ErrorOutlineIcon sx={{ color: "#dc2626" }} />
                              <div
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  color: "#dc2626",
                                }}
                              >
                                {errorCount} errors found
                              </div>
                            </div>
                          </Typography>
                        )}
                      </Typography>
                    </Typography>

                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        padding: 2,
                        minHeight: 200,
                        // Center content if it's just a few lines, otherwise align top
                        // display: processedResponse && processedResponse?.length > 0 ? 'block' : 'flex',
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "30px", // Apply margin as per your request
                        backgroundColor: "#f9fafb", // Apply background color as per your request
                      }}
                    >
                      <div
                        style={{
                          maxWidth: "100%",
                          color: "#000",
                          fontSize: "16px",
                        }}
                      >
                        {processedResponse}
                      </div>
                    </Box>

                    <Box sx={{ margin: "0 auto" }}>
                      <Box
                        sx={{
                          border: "2px solid #00b0ff",
                          borderRadius: "8px",
                          padding: "10px 16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          backgroundColor: "#fafafa",
                          margin: "10px 30px",
                        }}
                        onClick={() => setShowErrors((prev) => !prev)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <ErrorOutlineIcon sx={{ color: "#f44336" }} />
                          <Typography
                            sx={{ color: "#00b0ff", fontWeight: 500 }}
                          >
                            Error Explanations (
                            {
                              questions[currentQuestion - 1]?.explanation
                                ?.length
                            }
                            )
                          </Typography>
                        </Box>

                        <IconButton size="small" sx={{ color: "#00b0ff" }}>
                          {showErrors ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </Box>

                      {showErrors &&
                        Array.isArray(
                          questions[currentQuestion - 1]?.explanation
                        ) && (
                          <Box sx={{ padding: "6px 30px !important" }}>
                            {questions[
                              currentQuestion - 1
                            ]?.explanation.map(
                              (item: any, index: number) => (
                                <Box
                                  sx={{
                                    backgroundColor: "#fff5f5",
                                    border: "1px solid #f44336",
                                    borderRadius: "8px",
                                    padding: "12px 16px",
                                    mb: 2,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1.5,
                                      mb: 1,
                                    }}
                                  >
                                    <CircleIcon
                                      sx={{ fontSize: 10, color: "#f44336" }}
                                    />
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        color: "#991b1b",
                                        fontWeight: "bold",
                                        fontSize: 13,
                                      }}
                                    >
                                      "{item.highlight}"
                                    </Typography>
                                  </Box>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#2e2e2e",
                                      ml: 3,
                                      fontSize: 15,
                                    }}
                                  >
                                    {item.explanation}
                                  </Typography>
                                </Box>
                              )
                            )}
                          </Box>
                        )}
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                // width: "100%",
                typography: "body1",
                mt: 3,
                backgroundColor: "white",
                margin: "0px 6%",
                borderRadius: "10px",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  height: "70px",
                  background: "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "30px",
                  color: "#1e3a8a",
                  fontSize: "20px",
                  fontWeight: 500,
                  borderRadius: "10px 10px 0px 0px",
                }}
              >
                AI-Enhanced Results
              </Typography>

              <TabContext value={value}>
                <Box
                  sx={{
                    backgroundColor: "#f0f7ff", // light blue background
                    borderRadius: "10px",
                    padding: "3px",
                    display: "flex",
                    justifyContent: "center",
                    boxShadow: "inset 0 0 0 1px #cce4f7", // subtle border
                    m: "2%",
                  }}
                >
                  <TabList
                    onChange={handleChange}
                    TabIndicatorProps={{ style: { display: "none" } }} // removes underline
                    sx={{
                      minHeight: "0",
                      width: "100%",
                      "& .MuiTabs-flexContainer": {
                        display: "flex !important",
                        justifyContent: "space-between !important",
                      },
                    }} // remove default height
                  >
                    <Tab
                      label="Original"
                      value="1"
                      sx={{
                        textTransform: "none",
                        fontWeight: value === "1" ? "bold" : "500",
                        color: value === "1" ? "white" : "#4a6b8a",
                        backgroundColor:
                          value === "1" ? "#009dff" : "transparent",
                        borderRadius: "8px",
                        minHeight: "32px",
                        minWidth: "120px",
                        maxWidth: "33.3%",
                        px: 3,
                        transition: "all 0.3s ease",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "16px",
                      }}
                    />
                    <Tab
                      label="AI Rewrite"
                      value="2"
                      onClick={() => {
                        writeexamre("rewriting");
                        writeexam("aiwriting");
                      }}
                      sx={{
                        textTransform: "none",
                        fontWeight: value === "2" ? "bold" : "500",
                        color: value === "2" ? "white" : "#4a6b8a",
                        backgroundColor:
                          value === "2" ? "#009dff" : "transparent",
                        borderRadius: "8px",
                        minHeight: "32px",
                        minWidth: "120px",
                        maxWidth: "33.3%",
                        px: 3,
                        transition: "all 0.3s ease",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "pre-line",
                      }}
                    />
                    <Tab
                      label="AI Generate"
                      value="3"
                      onClick={() => {
                        dispatch(
                          listListWritingExamAIPracticeSlice({
                            student_test_id: view_id?.id,
                          })
                        );
                        writeexam("backwriting");
                        writeexamre("aiwritingre");
                      }}
                      sx={{
                        textTransform: "none",
                        fontWeight: value === "3" ? "bold" : "500",
                        color: value === "3" ? "white" : "#4a6b8a",
                        backgroundColor:
                          value === "3" ? "#009dff" : "transparent",
                        borderRadius: "8px",
                        minHeight: "32px",
                        minWidth: "120px",
                        maxWidth: "33.3%",
                        px: 3,
                        transition: "all 0.3s ease",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "16px",
                        whiteSpace: "pre-line",
                      }}
                    />
                  </TabList>
                </Box>

                <TabPanel value="1">
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2.5,
                      borderRadius: "12px",
                      backgroundColor: "#f9fafb",
                      border: "1px solid #e0e0e0",
                      fontSize: "18px",
                    }}
                  >
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>
                      <div>
                        {parseHtmlToParagraphs(
                          questions[currentQuestion - 1]?.response || ""
                        )}
                      </div>
                    </Typography>
                  </Paper>

                  <Alert
                    severity="warning"
                    icon={<ErrorOutlineIcon />}
                    sx={{
                      mt: 2,
                      backgroundColor: "#fff3e0",
                      color: "#e65100",
                      border: "1px solid #ffcc80",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                  >
                    Your original submission with{" "}
                    <strong>
                      {questions[currentQuestion - 1]?.explanation
                        ?.length ?? 0}
                    </strong>{" "}
                    highlighted errors to review and learn from.
                  </Alert>
                </TabPanel>

                <TabPanel value="2">
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2.5,
                      borderRadius: "12px",
                      background: "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>
                      {parseHtmlToParagraphs(
                        questions[currentQuestion - 1]?.rewritten_response || ""
                      )}
                    </Typography>
                  </Paper>
                  <Box
                    sx={{
                      backgroundColor: "#f1fdf6", // light green background
                      border: "1px solid #b2e7c9", // soft green border
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      mt: 2,
                    }}
                  >
                    <CheckCircleOutlineIcon sx={{ color: "#4caf50", mr: 1 }} />
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#1976d2",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      Your text rewritten by AI with corrections applied and
                      improved flow while maintaining your original ideas.
                    </Typography>
                  </Box>
                </TabPanel>

                <TabPanel value="3">
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2.5,
                      borderRadius: "12px",
                      background: "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                      border: "1px solid #e0e0e0",
                      fontSize: "18px",
                    }}
                  >
                    <Typography variant="body1" sx={{ fontSize: "17px" }}>
                      {parseHtmlToParagraphs(
                        AI?.questions[0]?.ai_response || ""
                      )}
                    </Typography>
                  </Paper>
                  <Box
                    sx={{
                      backgroundColor: "#f1fdf6", // light green background
                      border: "1px solid #b2e7c9", // soft green border
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      mt: 2,
                    }}
                  >
                    <CheckCircleOutlineIcon sx={{ color: "#4caf50", mr: 1 }} />
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#1976d2", // blue text
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      A completely new response generated by AI to show
                      different approaches to the same prompt.
                    </Typography>
                  </Box>
                </TabPanel>
              </TabContext>
            </Box>

            <Chatbot
              open={chatbotOpen}
              setOpen={setChatbotOpen}
              // state_value={view_id}
              // review_screen={WritingExamPracticeSlice?.data}
              questiondata={questions[currentQuestion - 1]?.question}
              imagedata={questions[currentQuestion - 1]?.question_url}
              passage={questions[currentQuestion - 1]?.prompt}
              instruction={questions[currentQuestion - 1]?.instruction}
            />
            {/* <div
              className="navigation-buttonslrepost"
              style={{
                position: "absolute",
                // top: "100%",
                display: "flex",
                padding: "16px",
                width: "100%",
                height: "75px",
                background: "#fff",
                zIndex: "0",
                justifyContent: "space-between",
              }}
            >
              <Button
                className="buttonnameprevious"
                sx={{ color: "#009DFF" }}
                onClick={() =>
                  setCurrentQuestion((prev) => Math.max(prev - 1, 1))
                }
                disabled={currentQuestion === 1}
              >
                <ArrowBackIcon sx={{ marginRight: "10px" }} /> Previous
              </Button>

              {currentQuestion === questions?.length ? (
                <Button
                  className="buttonnamenextresport"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setIsExamOver(false);
                    navigate("/examresultpractice", { state: view_id }); // Replace with your target route
                  }}
                >
                  Proceed to Report
                </Button>
              ) : (
                <Button
                  className="buttonnamenext"
                  sx={{ zIndex: 1111 }}
                  onClick={() => {
                    setCurrentQuestion((prev) =>
                      Math.min(prev + 1, questions?.length)
                    );
                  }}
                  disabled={currentQuestion === questions?.length}
                >
                  Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
                </Button>
              )}
            </div> */}

            <button
              className="floating-chatbot-button"
              style={{ marginBottom: "70px" }}
              onClick={() => setChatbotOpen(true)}
            >
              <img
                src={AvatarImage}
                alt="Chat with Elliot"
                className="chatbot-avatar"
              />
            </button>

            <AlterDialog
              alterheading={"View Solution"}
              alterableName={"Get Back to Report Page"}
              open={isExamOver}
              setOpen={setIsExamOver}
              buttonname={
                <>
                  <ButtonField
                    className="alter_button"
                    onClick={() => {
                      setIsExamOver(false);
                      navigate("/examresult", { state: view_id }); // Replace with your target route
                    }}
                  >
                    Ok
                  </ButtonField>
                </>
              }
            />
          </>
        ) : questions[currentQuestion - 1]?.question_type ===
          "Reading Comprehension" ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                padding: "10px ",
                margin: "0px 4% 10px 4%",
              }}
            >
              {/* Chat Suggestion Box */}
              <Paper
                elevation={0}
                sx={{
                  borderRadius: "12px",
                  padding: "16px  16px",
                  display: "flex",
                  justifyContent: "space-between",
                  background: "linear-gradient(to right, #e3f2fd, #e3f2fd)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                  alignItems: "center",
                  borderColor: "#bfdbfe",
                  borderWidth: "2px",
                  borderStyle: "solid",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <div className="blinking-avatar-container1">
                    <Avatar
                      src={AvatarImage}
                      alt="Profile"
                      className="blinking-avatar1"
                    />
                  </div>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "18px",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        color: "#1e3a8a",
                      }}
                    >
                      Need help understanding?
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "#424242" }}>
                      Chat with Elliot about this question!
                    </Typography>
                  </Box>
                </Stack>

                <Button
                  variant="contained"
                  startIcon={<ChatBubbleOutlineIcon />}
                  sx={{
                    borderRadius: "10px",
                    fontWeight: 600,
                    textTransform: "none",
                    px: 3,
                    py: 1,
                    color: "white",
                    fontSize: "15px",
                    backgroundColor: "#2196f3",
                    "&:hover": {
                      backgroundColor: "#1976d2",
                    },
                  }}
                  onClick={() => {
                    setChatbotOpen(true);
                    dispatch(clearChatbotPublicStatus());
                    dispatch(clearWritingChatbotPublicStatus());
                    dispatch(clearReadChatbotPublicStatus());
                  }}
                >
                  Chat with Elliot
                </Button>
              </Paper>
            </Box>
            <ChatbotPublic
              open={chatbotOpen}
              setOpen={setChatbotOpen}
              state_value={view_id}
              review_screen={listReViewExamIDSlice?.data}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "1% 4%",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: "14px", fontWeight: 500 }}>
                Question {currentQuestion} of {""}
                {questions?.length}
              </div>
            </div>
            <Card
              sx={{
                m: 2,
                borderRadius: "20px",
                // height: "100%",
                margin: "0px 4% 10px 4%",
                overflow: "visible",
                boxShadow: "none",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "black",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  justifyContent: "space-between",
                  padding: "25px",
                  backgroundColor: getBackgroundColor(
                    questions[currentQuestion - 1]?.options
                  ),
                  mb: 1,
                }}
              >
                <div style={{ fontSize: "16px" }}>
                  {questions[currentQuestion - 1]?.subtype_name}
                </div>
                <div
                  style={{
                    backgroundColor: feedback.bgColor,
                    padding: "8px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={feedback.image}
                    alt={feedback.label}
                    style={{ marginRight: 8, height: 16 }}
                  />
                  <div style={{ color: feedback?.color }}>
                    {feedback.label}
                  </div>
                </div>
              </Typography>
              <div className="overonlinedi">
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      color: "#111827",
                      fontWeight: 600,
                      fontSize: "1.7rem",
                      marginBottom: "20px",
                    }}
                  >
                    Passage:
                  </div>
                  <Typography
                    className="readingpassage"
                    sx={{
                      height: {
                        xs: "30vh", // small screen
                        sm: "35vh",
                        md: "40vh",
                        lg: "45vh",
                      },
                      overflow: "scroll",
                      fontWeight: 400,
                      border: "1px solid #cecece",
                      padding: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        marginBottom: "20px",
                        fontSize: "16px",
                        fontWeight: "500",
                        whiteSpace: "break-spaces",
                        lineHeight: "1.625",
                      }}
                    >
                      {questions[currentQuestion - 1]?.prompt}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        marginBottom: "20px",
                        fontSize: "17px",
                        fontWeight: "500",
                        whiteSpace: "break-spaces",
                      }}
                    >
                      {questions[currentQuestion - 1]?.instruction}
                    </Typography>
                  </Typography>
                </div>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    width: "100%",
                    padding: "10px",
                  }}
                >
                  <div className="examscrollreading">
                    <Typography variant="h5">
                      <div
                        style={{
                          color: "#111827",
                          fontWeight: 600,
                          fontSize: "1.7rem",
                          marginBottom: "20px",
                        }}
                      >
                        Question:
                      </div>
                      <Typography
                        sx={{
                          fontSize: "1.4rem",
                          marginBottom: "20px",
                          textAlign: "left",
                          fontWeight: 500,
                        }}
                      >
                        {questions[currentQuestion - 1]?.question}
                      </Typography>

                      {questions[currentQuestion - 1]?.question_url && (
                        <Typography
                          variant="h5"
                          sx={{
                            marginBottom: "20px",
                            textAlign: "left",
                            position: "relative", // Ensure proper positioning of the image
                            overflow: "visible", // Ensure the enlarged image is not clipped
                            "& img": {
                              maxWidth: "100%",
                              height:
                                List?.data?.questions_by_type[0]
                                  ?.question_type_name === "Writing"
                                  ? "30rem"
                                  : "100%",
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              position: "relative",
                              transformOrigin: "left center", // Keep the hover scaling aligned to the left
                            },
                            "& img:hover": {
                              transform: "scale(1.5)",
                            },
                          }}
                        >
                          <Box sx={{ mb: 2, textAlign: "center", width: "100%", alignItems: "center", justifyContent: "center", display: "flex" }}>
                            <img src={imageFile} alt="Uploaded preview"
                              className="resizable-image"
                              style={{ width: `${adaptImageWidth ? (questions[currentQuestion - 1]?.imgWidth || 90) : 99}%` }} />
                          </Box>
                        </Typography>
                      )}

                      <div
                        style={{
                          color: "#111827",
                          fontWeight: 600,
                          fontSize: "1.7rem",
                          marginBottom: "20px",
                        }}
                      >
                        Select your answer:
                      </div>
                      <Typography
                        variant="h5"
                        sx={{
                          marginBottom: "20px",
                          textAlign: "justify",
                          whiteSpace: "break-spaces",
                        }}
                      >
                        {List?.data?.questions?.length === 0 ? (
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "larger",
                              marginTop: "30%",
                            }}
                          >
                            No Question Found
                          </div>
                        ) : (
                          renderQuestionOptions(
                            currentQuestion,
                            questions[currentQuestion - 1]?.explanation || "",
                            questions[currentQuestion - 1]?.question_type,
                            questions[currentQuestion - 1]?.options || [],
                            questions[currentQuestion - 1]?.optionsurl || []
                          )
                        )}{" "}
                      </Typography>
                    </Typography>
                  </div>
                </Grid>
              </div>
            </Card>
            <Typography
              variant="body2"
              sx={{
                m: 3,
                fontSize: "14px",
                color: "#6b7280",
                textAlign: "center",
              }}
            >
              Keyboard shortcuts: → / ← to navigate,
            </Typography>
            <Chatbot
              open={chatbotOpen}
              setOpen={setChatbotOpen}
              // state_value={view_id}
              // review_screen={WritingExamPracticeSlice?.data}
              questiondata={questions[currentQuestion - 1]?.question}
              imagedata={questions[currentQuestion - 1]?.question_url}
              passage={questions[currentQuestion - 1]?.prompt}
              instruction={questions[currentQuestion - 1]?.instruction}
            />

            <button
              className="floating-chatbot-button"
              style={{ marginBottom: "70px" }}
              onClick={() => setChatbotOpen(true)}
            >
              <img
                src={AvatarImage}
                alt="Chat with Elliot"
                className="chatbot-avatar"
              />
            </button>

            <div
              className="navigation-buttonslrepost"
              style={{
                position: "absolute",
                display: "flex",
                padding: "16px",
                width: "100%",
                height: "75px",
                background: "#fff",
                zIndex: "0",
                justifyContent: "space-between",
              }}
            >
              {/* Previous Button */}
              <Button
                className="buttonnameprevious"
                sx={{ color: "#009DFF" }}
                onClick={() =>
                  setCurrentQuestion((prev) => Math.max(prev - 1, 1))
                }
                disabled={currentQuestion === 1}
              >
                <ArrowBackIcon sx={{ marginRight: "10px" }} /> Previous
              </Button>

              {/* Next / Back to Result Button */}
              {currentQuestion === questions?.length ? (
                <Button
                  className="buttonnamenext"
                  sx={{ zIndex: 1111 }}
                  onClick={() => navigate(-1)} // go back to previous page
                >
                  Back to Result
                </Button>
              ) : (
                <Button
                  className="buttonnamenext"
                  sx={{ zIndex: 1111 }}
                  onClick={() =>
                    setCurrentQuestion((prev) =>
                      Math.min(prev + 1, questions?.length)
                    )
                  }
                >
                  Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
                </Button>
              )}
            </div>
          </>
        ) : (
          <Grid
            item
            xs={12}
            md={6}
            sx={{ height: "100%", margin: "0px 4% 10px 4%" }}
          >
            <Typography variant="h5">
              <Card sx={{ m: 2, borderRadius: "20px", marginBottom: "70px" }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "black",
                    height: "35px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "16px",
                    fontWeight: 500,
                    textTransform: "capitalize",
                    justifyContent: "space-between",
                    padding: "25px",
                    backgroundColor: getBackgroundColor(
                      questions[currentQuestion - 1]?.options
                    ),
                    mb: 1,
                  }}
                >
                  <div style={{ fontSize: "16px" }}>
                    {questions[currentQuestion - 1]?.subtype_name}
                  </div>
                  <div
                    style={{
                      backgroundColor: feedback.bgColor,
                      padding: "8px",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={feedback.image}
                      alt={feedback.label}
                      style={{ marginRight: 8, height: 16 }}
                    />
                    <div style={{ color: feedback?.color }}>
                      {feedback.label}
                    </div>
                  </div>
                </Typography>
                <div style={{ margin: "2% 3%" }}>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, fontSize: "19px" }}
                  >
                    {questions[currentQuestion - 1]?.prompt}{" "}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, fontSize: "19px" }}
                  >
                    {questions[currentQuestion - 1]?.instruction}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, fontSize: "19px" }}
                  >
                    {questions[currentQuestion - 1]?.question}{" "}
                  </Typography>

                  {questions[currentQuestion - 1]?.question_url && (
                    <Box
                      sx={{
                        width: "100%",
                        bgcolor: "#f8f9fa",
                        borderRadius: "10px",
                        p: 2,
                        mb: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={imageFile} alt="Abstract reasoning question"
                        style={{ width: `${adaptImageWidth ? (questions[currentQuestion - 1]?.imgWidth || 90) : 99}%` }} />
                    </Box>
                  )}
                  <Grid container spacing={2}>
                    {List?.data?.questions?.length === 0 ? (
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "larger",
                          marginTop: "30%",
                        }}
                      >
                        No Question Found
                      </div>
                    ) : (
                      renderQuestionOptions(
                        currentQuestion,
                        questions[currentQuestion - 1]?.answer_explanation || "",
                        questions[currentQuestion - 1]?.question_type,
                        questions[currentQuestion - 1]?.options || [],
                        questions[currentQuestion - 1]?.optionsurl || []
                      )
                    )}
                  </Grid>
                </div>
              </Card>
              <Typography
                variant="body2"
                sx={{
                  m: 3,
                  fontSize: "14px",
                  color: "#6b7280",
                  textAlign: "center",
                }}
              >
                Keyboard shortcuts: → / ← to navigate,
              </Typography>
            </Typography>
            <div
              className="navigation-buttonslrepost"
              style={{
                position: "absolute",
                display: "flex",
                padding: "16px",
                width: "100%",
                height: "75px",
                background: "#fff",
                zIndex: "0",
                justifyContent: "space-between",
              }}
            >
              {/* Previous Button */}
              <Button
                className="buttonnameprevious"
                sx={{ color: "#009DFF" }}
                onClick={() =>
                  setCurrentQuestion((prev) => Math.max(prev - 1, 1))
                }
                disabled={currentQuestion === 1}
              >
                <ArrowBackIcon sx={{ marginRight: "10px" }} /> Previous
              </Button>

              {/* Next / Back to Result Button */}
              {currentQuestion === questions?.length ? (
                <Button
                  className="buttonnamenext"
                  sx={{ zIndex: 1111 }}
                  onClick={() => navigate(-1)} // go back to previous page
                >
                  Back to Result
                </Button>
              ) : (
                <Button
                  className="buttonnamenext"
                  sx={{ zIndex: 1111 }}
                  onClick={() =>
                    setCurrentQuestion((prev) =>
                      Math.min(prev + 1, questions?.length)
                    )
                  }
                >
                  Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
                </Button>
              )}
            </div>
          </Grid>
        )}

        <AlterDialog
          alterheading={"View Solution"}
          alterableName={"Get Back to Report Page"}
          open={isExamOver}
          setOpen={setIsExamOver}
          buttonname={
            <>
              <ButtonField
                className="alter_button"
                onClick={() => {
                  setIsExamOver(false);
                  navigate("/examresult", { state: view_id });
                }}
              >
                Ok
              </ButtonField>
            </>
          }
        />
        <React.Fragment>
          <Dialog
            open={openreview}
            onClose={handleClosereview}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{
                display: "flex",
                justifyItems: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <ReportGmailerrorredIcon
                sx={{ fontSize: "50px", color: "#009dff" }}
              />
              <div style={{ fontSize: "20px", color: "#009dff" }}>Warning</div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ fontSize: "15px" }}
              >
                {List?.message}{" "}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <ButtonField
                className="form_save_button"
                onClick={() => {
                  setOpenreview(false);
                  navigate("/examresultpractice", { state: view_id }); // Replace with your target route
                  if (view_id?.id) {
                    dispatch(clearListWritingExamPracticeSlice());
                  } else {
                    dispatch(clearListReViewExamIDPractice());
                  }
                }}
              >
                Back to Report
              </ButtonField>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
      {questions[currentQuestion - 1]?.question_type === "Writing" ? (
        <div
          className="navigation-buttonsl"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <Button
              className="buttonnamenextret"
              onClick={() => {
                writeexamre("rewriting");
                writeexam("aiwriting");
                setValue("2"); // Switch to AI Rewrite tab
              }}
            >
              View AI Rewrite
            </Button>

            <Button
              className="buttonnamenextret"
              title="Click to generate AI's own version of the writing for reference"
              onClick={() => {
                dispatch(
                  listListWritingExamAIPracticeSlice({
                    student_test_id: view_id?.id,
                  })
                );
                writeexam("backwriting");
                writeexamre("aiwritingre");
                setValue("3"); // Switch to AI Generate tab
              }}
            >
              View AI Generate
            </Button>

            {currentQuestion === questions?.length ? (
              <Button
                className="buttonnamenextortwrite"
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsExamOver(false);
                  navigate("/examresultpractice", {
                    state: {
                      id: view_id?.id,
                      type: "writing",
                      showSubmitAlert: false,
                    },
                  });
                }}
              >
                Back to Results
              </Button>
            ) : (
              <Button
                className="buttonnamenext5"
                sx={{ zIndex: 1111 }}
                onClick={() => {
                  setCurrentQuestion((prev) =>
                    Math.min(prev + 1, questions?.length)
                  );
                }}
                disabled={currentQuestion === questions?.length}
              >
                Next
              </Button>
            )}
          </div>
        </div>
      ) : (
        <div className="navigation-buttonslrepost">
          <Button
            className="buttonnameprevious"
            sx={{ color: "#009DFF" }}
            onClick={() => setCurrentQuestion((prev) => Math.max(prev - 1, 1))}
            disabled={currentQuestion === 1}
          >
            <ArrowBackIcon sx={{ marginRight: "10px" }} /> Previous
          </Button>

          {currentQuestion === questions?.length ? (
            <Button
              className="buttonnamenext5"
              sx={{ zIndex: 1111 }}
              onClick={() => {
                setIsExamOver(false);
                navigate("/examresultpractice", {
                  state: {
                    id: view_id,
                    showSubmitAlert: false,
                  },
                });
              }}
            >
              Proceed to Report
            </Button>
          ) : (
            <Button
              className="buttonnamenext5"
              sx={{ zIndex: 1111 }}
              onClick={() => {
                setCurrentQuestion((prev) =>
                  Math.min(prev + 1, questions?.length)
                );
              }}
              disabled={currentQuestion === questions?.length}
            >
              Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default ReViewExamPractice;
